import React  from 'react';
import CompetitionFilter from '../../../admin/components/competitionFilter';


const TableHeader = (props) => {
  const { disabled, onSubmit } = props;

  return <CompetitionFilter disabled={disabled} onSubmit={onSubmit}/>;
};

export default TableHeader;



// WEBPACK FOOTER //
// ./src/private/common/components/TechnicalControls/Header.js